import React, { FC } from 'react'
import { Row, Col } from 'reactstrap';
import { AEAField } from '@components/'
import { ProaSummaryPresenter } from '@presenters/screens/proa-summary.presenter';

export interface IBaseDataProaRRHHsProps {
    presenter: ProaSummaryPresenter
};

const BaseDataProaRRHH: FC<any> = (props: IBaseDataProaRRHHsProps) => {

    return (
        <div>
            <Row xs="1" sm="2" md="2" lg="2" xl="2">
                <Col><AEAField {...props.presenter.getTotalPersonasNecesariasField }></AEAField></Col>                
            </Row>
            <Row xs="1" sm="3" md="3" lg="3" xl="3">
                <Col><AEAField {...props.presenter.getTipoGerenteProyectoField }></AEAField></Col>
                <Col><AEAField {...props.presenter.getDedicacionGerenteField }></AEAField></Col>
                <Col><AEAField {...props.presenter.getIdentificacionGerenteField }></AEAField></Col>
            </Row>
            <Row xs="1" sm="3" md="3" lg="3" xl="3">
                <Col><AEAField {...props.presenter.getTipoAdministradorField }></AEAField></Col>
                <Col><AEAField {...props.presenter.getDedicacionAdministradoreField }></AEAField></Col>
                <Col> <AEAField {...props.presenter.getIdentificacionAdministradorField }></AEAField></Col>
            </Row>            
        </div>
    )
}

export default BaseDataProaRRHH;
